export const TYPE_CLUB_LOGO = 'club_logo';
export const TYPE_CUSTOM_LOGO = 'custom_logo';
export const TYPE_TEXT = 'text';
export const TYPE_FREE_TEXT = 'free_text';
